// extracted by mini-css-extract-plugin
module.exports = {"Container":"_1UOB3JCHodBJtwywwtqkx","Img":"_2FOA5xCcHlSGa1XwlGQkM"};